import { useMemo, useRef } from 'react';

import { ChevronLeft, ChevronRight } from '@mint-lib/icons';
import { Button } from '@mint-lib/tw-components';
import type { Suggestions } from '@mint-sdk/api-recommendations';

import { useWidgetCarousel } from '../../../hooks/useWidgetCarousel.js';
import WidgetCard from '../WidgetCard/WidgetCard.jsx';

type WidgetCarouselProps = {
  suggestion: Suggestions.SuggestionResponseType;
};

const WidgetCarousel = ({ suggestion }: WidgetCarouselProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const widgetsData = useMemo(
    () =>
      suggestion?.taxonomy.forecastedKpi.widget
        .sort((widget) => (widget.isPrimary ? -1 : 1))
        .map((widget) => {
          return { ...widget, currency: suggestion.currency };
        }),
    [suggestion],
  );
  const { activeSliders, moveToRight, moveToLeft, needToLeft, needToRight } =
    useWidgetCarousel({
      data: widgetsData ?? [],
      ref,
    });

  return (
    <div className="flex flex-row items-center gap-2" ref={ref}>
      {needToLeft && (
        <Button
          size={'small'}
          onClick={() => moveToLeft()}
          variant={'outlined'}
        >
          <ChevronLeft />
        </Button>
      )}

      <div className="flex w-full flex-row gap-4">
        {activeSliders.map((widget) => (
          <WidgetCard widget={widget} key={widget.label} />
        ))}
      </div>

      {needToRight && (
        <Button
          size={'small'}
          onClick={() => moveToRight()}
          variant={'outlined'}
        >
          <ChevronRight />
        </Button>
      )}
    </div>
  );
};

export default WidgetCarousel;
